<template>
  <modal
    :show="show"
    @close="close()"
  >
    <div class="data-transfer-modal__container">
      <div class="data-transfer-modal__content">
        <h1 class="data-transfer-modal__headline">
          {{ $t('VMX.data_transfer_headline') }}
        </h1>
        <p class="data-transfer-modal__description">
          {{ $t('VMX.data_transfer_description') }}
        </p>
        <div class="data-transfer-modal__options">
          <div class="data-transfer-modal__options-one">
            <div class="data-transfer-modal__data">
              <h5 class="data-transfer-modal__data-headline">
                {{ $t('VMX.data_transfer_option_one_headline') }}
              </h5>
              <p
                class="data-transfer-modal__data-information"
                v-html="$t('VMX.data_transfer_option_one_information')"
              />
              <b-button
                variant="primary"
                target="_blank"
                :href="urlWithData"
                @click="setCookie(true)"
              >
                {{ $t('VMX.data_transfer_option_one_button') }}
              </b-button>
            </div>
          </div>

          <div class="data-transfer-modal__options-two">
            <div class="data-transfer-modal__anonym">
              <p>
                {{ $t('VMX.data_transfer_option_two_headline') }}
              </p>
              <b-button
                variant="primary"
                target="_blank"
                :href="urlAnonymized"
                @click="setCookie(false)"
              >
                {{ $t('VMX.data_transfer_option_two_button') }}
              </b-button>
            </div>
            <div class="data-transfer-modal__return">
              <p>
                {{ $t('VMX.data_transfer_return_headline') }}
              </p>
              <b-button
                variant="primary"
                @click="close()"
              >
                {{ $t('VMX.data_transfer_return_button') }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    modal: () => import('../index.vue'),
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      instance: 'instancesState/getInstance',
      event: 'instancesState/getEvent',
      token: 'instancesState/getToken',
    }),
    urlWithData() {
      return `${this.url}&includeLeadData=True&token=${this.token}`
    },
    urlAnonymized() {
      return `${this.url}&includeLeadData=False&token=${this.token}`
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    setCookie(boolean) {
      this.$cookies.set('externalDataTransfer', boolean, '72h')
      this.close()
      this.$root.$emit('rerender')
    },
  },
}

</script>
